import { useState, useRef, useEffect } from "react";
import "../../../styles/panel/user/AddShopProduct.css";
import ApfDescriptionEditor from "./ApfDescriptionEditor";
import { API_BASE_URL } from "../../../api/http";
import {
  createProduct,
  updateProduct,
  uploadProductImages,
  deleteProductImage,
  addAttribute,
  deleteAttribute,
  addColor,
  deleteColor,
  updateImageCover,
} from "../../../api/product_management/productApi";
import { compressImage } from "../../../utils/imageCompressor";

import {
  getCategories,
  createCategory, // ⚠️ اگه اسم/پارامترهای واقعی تابع فرق داره، پایین در handleAddCategory اصلاحش کن
} from "../../../api/product_management/categoryApi";
import { getCollections } from "../../../api/product_management/collectionApi";
import { swalError, swalSuccess } from "../../../utils/swalAlert";
// ⚠️ مسیر رو با فایلی که hasProMajazi توش تعریف شده هماهنگ کن
import { hasProMajazi } from "../../../api/proMajazi";

// نگاشت برعکسِ UNIT_CODE، برای نمایش برچسب فارسیِ واحدِ محصولِ در حال ویرایش
const UNIT_LABEL_FA = { piece: "عدد", kg: "کیلو", pack: "بسته" };
// خروجی رشته یا آبجکت {id,...} رو به آیدی خام تبدیل می‌کنه (سازگار با category/collections از بک‌اند)
const idOf = (v) => (v && typeof v === "object" ? v.id : v);
const resolveImgUrl = (src) =>
  src?.startsWith("http") ? src : `${API_BASE_URL}${src}`;

// برای نمایش عدد با جداکننده هزارگان (۱٬۰۰۰٬۰۰۰) در فیلدهای قیمت/موجودی
// - state همیشه فقط رقم خام (بدون کاما) نگه می‌داره؛ نمایش با فرمت جداست
const formatThousands = (val) => {
  if (val === "" || val === null || val === undefined) return "";
  const digits = String(val).replace(/[^\d]/g, "");
  if (!digits) return "";
  return digits.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
// از روی مقدار تایپ‌شده (که ممکنه کاما هم داشته باشه) فقط رقم خام رو برمی‌گردونه
const onlyDigits = (val) => String(val ?? "").replace(/[^\d]/g, "");

// هم‌راستا با ProductCreate.jsx: برچسب فارسی واحد به کد مورد انتظار بک‌اند
const UNIT_CODE = { عدد: "piece", کیلو: "kg", بسته: "pack" };
/* آیکن‌های ساده SVG هم‌راستا با بقیه‌ی پروژه (stroke-based) */
const Icon = {
  Back: (p) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <path d="M5 12h14M12 5l7 7-7 7" />
    </svg>
  ),
  Info: (p) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <circle cx="12" cy="12" r="9" />
      <path d="M12 16v-4M12 8h.01" />
    </svg>
  ),
  Tag: (p) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <path d="M20.59 13.41 11 3.83A2 2 0 0 0 9.59 3.2L4 3a1 1 0 0 0-1 1l.2 5.59a2 2 0 0 0 .58 1.41l9.6 9.6a2 2 0 0 0 2.82 0l4.4-4.4a2 2 0 0 0 0-2.79Z" />
      <circle cx="7.5" cy="7.5" r="1.2" fill="currentColor" stroke="none" />
    </svg>
  ),
  Grid: (p) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <rect x="3" y="3" width="7" height="7" rx="1.5" />
      <rect x="14" y="3" width="7" height="7" rx="1.5" />
      <rect x="3" y="14" width="7" height="7" rx="1.5" />
      <rect x="14" y="14" width="7" height="7" rx="1.5" />
    </svg>
  ),
  Storefront: (p) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <path d="M3 9.5 4.5 4h15L21 9.5" />
      <path d="M3 9.5a2.5 2.5 0 0 0 5 0 2.5 2.5 0 0 0 5 0 2.5 2.5 0 0 0 5 0 2.5 2.5 0 0 0 5 0" />
      <path d="M5 10v10h14V10" />
      <path d="M10 20v-5.5a2 2 0 0 1 4 0V20" />
    </svg>
  ),
  Image: (p) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <rect x="3" y="3" width="18" height="18" rx="3" />
      <circle cx="8.5" cy="8.5" r="1.5" />
      <path d="m21 15-5-5L5 21" />
    </svg>
  ),
  Plus: (p) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <path d="M12 5v14M5 12h14" />
    </svg>
  ),
  Sparkle: (p) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5 18 18M18 6l-2.5 2.5M8.5 15.5 6 18" />
    </svg>
  ),
  Palette: (p) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <path d="M12 2a10 10 0 1 0 0 20c1.1 0 2-.9 2-2 0-.5-.2-1-.5-1.3-.3-.4-.5-.8-.5-1.3 0-1.1.9-2 2-2h2.3A4.2 4.2 0 0 0 21.5 11 9.9 9.9 0 0 0 12 2Z" />
      <circle cx="7" cy="11" r="1" fill="currentColor" stroke="none" />
      <circle cx="10" cy="7" r="1" fill="currentColor" stroke="none" />
      <circle cx="15" cy="7" r="1" fill="currentColor" stroke="none" />
    </svg>
  ),
  Check: (p) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <path d="M20 6 9 17l-5-5" />
    </svg>
  ),
  X: (p) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <path d="M18 6 6 18M6 6l12 12" />
    </svg>
  ),
  Star: (p) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <path d="m12 2 3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2Z" />
    </svg>
  ),
};

const UNIT_OPTIONS = ["عدد", "کیلو", "بسته"];

// حداکثر حجم مجاز برای هر عکس (۱ مگابایت)
const MAX_IMAGE_SIZE = 1 * 1024 * 1024;

// پرامپت آماده برای ساخت/اصلاح عکس پرومجازی با هوش مصنوعی (فروشنده عکس محصولش رو همراه پرامپت می‌ده)
const PRO_PROMPT_FA =
  "عکس محصولی که پیوست کرده‌ام را به یک عکس استاندارد برای پرو مجازی تبدیل کن. " +
  "خودِ محصول را دقیقاً با همان رنگ، طرح، جنس، جزئیات و تناسب‌ها نگه دار و هیچ چیزی به آن اضافه یا از آن کم نکن. " +
  "محصول را از روبه‌رو و کامل، در مرکز تصویر و بدون بریدگی از هیچ طرف قرار بده. " +
  "پس‌زمینه ساده و یک‌رنگ سفید یا خاکستری روشن باشد. " +
  "نور یکنواخت و نرم باشد، بدون سایهٔ شدید و بدون بازتاب نور فلاش. " +
  "هیچ فرد، مدل، دست، لوگو، واترمارک، متن، قاب یا وسیلهٔ اضافه‌ای در تصویر نباشد. " +
  "فقط یک محصول در تصویر باشد. " +
  "خروجی با کیفیت بالا، واضح و مربعی (حداقل ۱۰۰۰×۱۰۰۰ پیکسل) باشد.";
const PRO_PROMPT_EN =
  "Convert the attached product photo into a clean try-on-ready product image. " +
  "Keep the product exactly the same: same color, pattern, material, details and proportions. Do not add or remove anything. " +
  "Show the product from the front, fully visible and centered, with nothing cropped. " +
  "Use a plain solid white or light gray background. " +
  "Use soft, even lighting with no harsh shadows and no flash glare. " +
  "No people, models, hands, logos, watermarks, text, borders or extra objects. " +
  "Only one product in the image. " +
  "Output a sharp, high-quality square image (at least 1000x1000 pixels).";

export default function AddShopProduct({
  shop,
  product, // اختیاری: در حالت ویرایش، آبجکت محصول موجود (خروجی getProducts) پاس داده می‌شود
  onBack,
  onSubmit,
  submitting: submittingProp,
}) {
  console.log(shop);
  const isEdit = Boolean(product);

  const [name, setName] = useState(product?.name || "");
  const [unit, setUnit] = useState(
    UNIT_LABEL_FA[product?.unit] || product?.unit || UNIT_OPTIONS[0],
  );
  const [description, setDescription] = useState(product?.description || "");

  const [price, setPrice] = useState(product?.price ?? "");
  const [discountPrice, setDiscountPrice] = useState(
    product?.discount_price ?? "",
  );
  const [stock, setStock] = useState(product?.stock ?? "");

  // { id, url, file, existingId? } — existingId یعنی این تصویر از قبل روی سرور بوده
  const [images, setImages] = useState(() =>
    (product?.images || []).map((img) => ({
      id: `existing-${img.id}`,
      url: resolveImgUrl(img.image),
      file: null,
      existingId: img.id,
    })),
  );
  const [coverId, setCoverId] = useState(() => {
    const cover = (product?.images || []).find((img) => img.is_cover);
    return cover ? `existing-${cover.id}` : null;
  });
  // تصویری که برای «پرومجازی» (پرو آنلاین) استفاده می‌شه؛ اختیاری و حداکثر یکی
  const [proId, setProId] = useState(() => {
    const pro = (product?.images || []).find((img) => img.is_pro_majazi);
    return pro ? `existing-${pro.id}` : null;
  });
  const [removedImageIds, setRemovedImageIds] = useState([]); // آیدی تصاویرِ موجودی که حذف شده‌اند
  const fileInputRef = useRef(null);

  const [attrName, setAttrName] = useState("");
  const [attrValue, setAttrValue] = useState("");
  // { id, name, value, existingId? }
  const [attributes, setAttributes] = useState(() =>
    (product?.attributes || []).map((f, i) => ({
      id: `existing-${f.id ?? i}`,
      existingId: f.id,
      name: f.title || f.name || "",
      value: f.value || "",
    })),
  );
  const [removedAttributeIds, setRemovedAttributeIds] = useState([]);

  const [colorName, setColorName] = useState("");
  const [colorHex, setColorHex] = useState("#a23b52");
  // { id, name, hex, existingId? }
  const [colors, setColors] = useState(() =>
    (product?.colors || []).map((c, i) => ({
      id: `existing-${c.id ?? i}`,
      existingId: c.id,
      name: c.name || "",
      hex: c.hex || c.hex_code || c.code || "#a23b52",
    })),
  );
  const [removedColorIds, setRemovedColorIds] = useState([]);

  const [submittingState, setSubmittingState] = useState(false);
  // پیشرفت آپلود تصاویر: { done, total } یا null وقتی آپلودی در جریان نیست
  const [uploadState, setUploadState] = useState(null);

  const [categories, setCategories] = useState([]);
  const [collections, setCollections] = useState([]);

  // دسته‌بندی اصلی و زیردسته‌بندی به‌صورت جدا نگه داشته می‌شن.
  // اگه محصول (در حالت ویرایش) به‌صورت آبجکت با فیلد parent اومده باشه،
  // همینجا می‌تونیم بفهمیم زیردسته‌ست یا نه؛ اگر فقط آیدی خام بود،
  // بعد از لود شدن لیست کامل دسته‌ها (در fetchCategories) مشخصش می‌کنیم.
  const initialCategoryState = (() => {
    const raw = product?.category;
    if (raw && typeof raw === "object") {
      const parentId = idOf(raw.parent);
      return parentId
        ? { main: parentId, sub: raw.id }
        : { main: raw.id, sub: "" };
    }
    return { main: raw ?? "", sub: "" };
  })();
  const [category, setCategory] = useState(initialCategoryState.main);
  const [subCategory, setSubCategory] = useState(initialCategoryState.sub);

  // فرم اضافه‌کردن دسته‌بندی جدید (بدون خروج از صفحه)
  const [showAddCategory, setShowAddCategory] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState("");
  const [newCategoryParent, setNewCategoryParent] = useState("");
  const [addingCategory, setAddingCategory] = useState(false);

  // آرایه‌ای از id ویترین‌های انتخاب‌شده
  const [showcases, setShowcases] = useState(() => {
    const list =
      product?.collections || (product?.collection ? [product.collection] : []);
    return list.map(idOf).filter((v) => v !== undefined && v !== null);
  });

  const submitting = submittingProp ?? submittingState;
  const shopId = shop.store_id;

  // آیا این فروشگاه پرومجازی داره؟ (تا قبل از رسیدن جواب false، که دکمه چشمک نزنه)
  const [proEnabled, setProEnabled] = useState(false);
  // کدوم پرامپت (fa/en) تازه کپی شده؛ برای نمایش «کپی شد»
  const [copiedPrompt, setCopiedPrompt] = useState(null);
  const copyProPrompt = async (lang) => {
    const text = lang === "fa" ? PRO_PROMPT_FA : PRO_PROMPT_EN;
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = text;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    setCopiedPrompt(lang);
    setTimeout(() => setCopiedPrompt(null), 2000);
  };

  // دسته‌های اصلی: بدون parent | زیردسته‌های دسته‌ی اصلیِ انتخاب‌شده: parent === category
  const mainCategories = categories.filter((c) => !idOf(c.parent));
  const subCategories = categories.filter(
    (c) => category && idOf(c.parent) === Number(category),
  );

  const fetchCategories = () => {
    if (!shopId) return;
    getCategories(shopId)
      .then((res) => {
        const list = res.data?.results || res.data || [];
        setCategories(list);
        // اگه داده‌ی اولیه‌ی محصول فقط یک آیدی خام بود (نه آبجکت با parent)،
        // حالا که لیست کامل دسته‌ها لود شده می‌تونیم اصلی/زیردسته بودنش رو تشخیص بدیم
        if (product?.category && typeof product.category !== "object") {
          const found = list.find((c) => c.id === Number(product.category));
          if (found) {
            const parentId = idOf(found.parent);
            if (parentId) {
              setCategory(parentId);
              setSubCategory(found.id);
            } else {
              setCategory(found.id);
            }
          }
        }
      })
      .catch((err) =>
        console.log("CATEGORY ERROR:", err.response?.data || err.message),
      );
  };

  useEffect(() => {
    fetchCategories();
    if (!shopId) return;
    getCollections(shopId)
      .then((res) => setCollections(res.data?.results || res.data || []))
      .catch((err) =>
        console.log("COLLECTION ERROR:", err.response?.data || err.message),
      );

    hasProMajazi(shopId)
      .then((res) => {
        const d = res.data;
        // با هر دو شکل خروجی کار می‌کنه: true/false خام یا آبجکت
        setProEnabled(
          typeof d === "boolean"
            ? d
            : Boolean(d?.has_pro_majazi ?? d?.has ?? d?.enabled),
        );
      })
      .catch(() => setProEnabled(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopId]);

  const closeAddCategoryModal = () => {
    setShowAddCategory(false);
    setNewCategoryName("");
    setNewCategoryParent("");
  };

  const handleAddCategory = async () => {
    if (!newCategoryName.trim() || addingCategory) return;
    setAddingCategory(true);
    try {
      const payload = {
        name: newCategoryName.trim(),
        parent: newCategoryParent ? Number(newCategoryParent) : null,
        sort_order: 0,
      };
      const res = await createCategory(shopId, payload);
      const created = res.data;

      fetchCategories(); // لیست دسته‌ها رو دوباره از سرور می‌گیریم تا کاملاً sync باشه

      // دسته‌ی تازه‌ساخته‌شده رو خودکار به‌عنوان انتخاب فعلی ست می‌کنیم
      if (newCategoryParent) {
        setCategory(Number(newCategoryParent));
        setSubCategory(created.id);
      } else {
        setCategory(created.id);
        setSubCategory("");
      }

      closeAddCategoryModal();
    } catch (err) {
      console.log("ADD CATEGORY ERROR:", err.response?.data || err.message);
      swalError({
        text: err?.response?.data?.detail || "خطا در افزودن دسته‌بندی.",
      });
    } finally {
      setAddingCategory(false);
    }
  };

  const toggleShowcase = (id) => {
    setShowcases((prev) =>
      prev.includes(id) ? prev.filter((s) => s !== id) : [...prev, id],
    );
  };

  const handleFiles = async (fileList) => {
    const allFiles = Array.from(fileList || []);
    if (!allFiles.length) return;

    // ریست اینپوت تا در صورت نیاز بشه همون فایل رو دوباره انتخاب کرد
    if (fileInputRef.current) fileInputRef.current.value = "";

    try {
      // فشرده‌سازی خودکار همه عکس‌ها به زیر ۱ مگابایت با Canvas مرورگر
      const compressedFiles = await Promise.all(
        allFiles.map((file) => compressImage(file, 1, 1920)),
      );

      const next = compressedFiles.map((file) => ({
        id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        url: URL.createObjectURL(file),
        file,
      }));

      setImages((prev) => {
        const merged = [...prev, ...next];
        if (!coverId && merged.length) setCoverId(merged[0].id);
        return merged;
      });
    } catch (err) {
      console.error("خطا در بهینه‌سازی تصویر:", err);
      swalError({ text: "مشکلی در بهینه‌سازی تصاویر به وجود آمد." });
    }
  };

  const removeImage = (id) => {
    const removed = images.find((img) => img.id === id);
    if (removed?.existingId) {
      // بدون تکرار (side-effect داخل updater باعث ثبت دوباره‌ی id در StrictMode می‌شد)
      setRemovedImageIds((r) =>
        r.includes(removed.existingId) ? r : [...r, removed.existingId],
      );
    }
    if (removed?.file) URL.revokeObjectURL(removed.url);
    const next = images.filter((img) => img.id !== id);
    setImages(next);
    if (coverId === id) setCoverId(next.length ? next[0].id : null);
    if (proId === id) setProId(null);
  };

  // انتخاب/لغو انتخاب تصویر پرومجازی (کلیک دوباره روی همون تصویر، انتخاب رو برمی‌داره)
  const toggleProImage = (id) => {
    setProId((prev) => (prev === id ? null : id));
  };

  const addAttr = () => {
    if (!attrName.trim() || !attrValue.trim()) return;
    setAttributes((prev) => [
      ...prev,
      { id: `${Date.now()}`, name: attrName.trim(), value: attrValue.trim() },
    ]);
    setAttrName("");
    setAttrValue("");
  };

  const removeAttribute = (id) => {
    setAttributes((prev) => {
      const removed = prev.find((a) => a.id === id);
      if (removed?.existingId) {
        setRemovedAttributeIds((r) => [...r, removed.existingId]);
      }
      return prev.filter((a) => a.id !== id);
    });
  };

  const addCol = () => {
    if (!colorName.trim()) return;
    setColors((prev) => [
      ...prev,
      { id: `${Date.now()}`, name: colorName.trim(), hex: colorHex },
    ]);
    setColorName("");
  };

  const removeColor = (id) => {
    setColors((prev) => {
      const removed = prev.find((c) => c.id === id);
      if (removed?.existingId) {
        setRemovedColorIds((r) => [...r, removed.existingId]);
      }
      return prev.filter((c) => c.id !== id);
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;

    // بدون انتخاب دسته‌بندی، محصول ثبت/ویرایش نمی‌شه
    if (!category) {
      swalError({ text: "لطفاً یک دسته‌بندی برای محصول انتخاب کنید." });
      return;
    }

    setSubmittingState(true);

    try {
      // ساختار payload هم‌راستا با createProduct در ProductCreate.jsx
      const payload = {
        name: name || "",
        description: description || "",
        price: price ? Number(price) : 0,
        discount_price: discountPrice ? Number(discountPrice) : null,
        stock: stock ? Number(stock) : 0,
        unit: UNIT_CODE[unit] || "piece",
        // اگه زیردسته انتخاب شده باشه همون به‌عنوان دسته‌ی نهایی محصول ارسال می‌شه،
        // وگرنه دسته‌ی اصلیِ انتخاب‌شده
        category: subCategory ? Number(subCategory) : Number(category),
        collections: showcases,
        store: Number(shopId),
      };

      if (isEdit) {
        // --- حالت ویرایش ---
        console.log(product);
        await updateProduct(product.store, product.id, payload);

        // ۱) حذف تصاویری که از قبل روی سرور بودند و کاربر حذفشان کرده
        for (const imgId of removedImageIds) {
          await deleteProductImage(imgId);
        }

        // ۲) آپلود تصاویر جدیدی که در این ویرایش اضافه شده‌اند
        const newImages = images.filter((i) => i.file);
        const newServerIds = {}; // { [localImgId]: serverId } برای تصاویر تازه‌آپلودشده که کاور/پرومجازی هستن
        for (const [idx, img] of newImages.entries()) {
          setUploadState({ done: idx, total: newImages.length });
          const res = await uploadProductImages(product.id, [
            {
              file: img.file,
              is_cover: img.id === coverId,
              is_pro_majazi: img.id === proId,
            },
          ]);
          if (img.id === coverId || img.id === proId) {
            // بسته به خروجی uploadProductImages ممکنه res.data آرایه باشه
            newServerIds[img.id] = Array.isArray(res.data)
              ? res.data[0]?.id
              : res.data?.id;
          }
        }

        setUploadState(null);

        // ۳) اعمال کاور و پرومجازی
        // یک تصویر می‌تونه هم کاور باشه و هم پرومجازی. هر تصویری که یکی از این دو
        // وضعیتش عوض شده، «هر دو فیلدِ نهایی‌اش» (is_cover و is_pro_majazi) با هم و
        // در یک درخواست فرستاده می‌شه؛ نه فقط فیلدی که تغییر کرده. (مثلاً اگه تصویرِ
        // کاور رو پرومجازی هم کردن، is_cover: true هم باید همراهش بره.)
        // ⚠️ فرض: updateImageCover یک PATCH روی خود تصویره و هر دو فیلد رو قبول می‌کنه.
        const originalCoverId = (product.images || []).find(
          (i) => i.is_cover,
        )?.id;
        const originalProId = (product.images || []).find(
          (i) => i.is_pro_majazi,
        )?.id;

        // آیدی سروری هر تصویر داخل فرم (موجود: existingId | تازه‌آپلودشده: newServerIds)
        const serverIdOf = (img) => img?.existingId ?? newServerIds[img?.id];
        const coverImg = images.find((i) => i.id === coverId);
        const proImg = images.find((i) => i.id === proId);

        const touched = new Set(); // آیدی سروریِ تصاویری که باید PATCH بشن
        const touch = (id) => id && touched.add(String(id));

        // کاور
        if (coverImg?.existingId) {
          if (coverImg.existingId !== originalCoverId)
            touch(coverImg.existingId);
        } else if (coverImg) {
          touch(serverIdOf(coverImg));
        }

        // پرومجازی
        if (proImg?.existingId) {
          if (proImg.existingId !== originalProId) touch(proImg.existingId);
        } else if (proImg) {
          touch(serverIdOf(proImg));
        } else if (originalProId && !removedImageIds.includes(originalProId)) {
          // کاربر انتخابِ تصویر پرومجازی رو برداشته
          touch(originalProId);
        }

        for (const id of touched) {
          const img = images.find((i) => String(serverIdOf(i)) === id);
          await updateImageCover(id, {
            is_cover: Boolean(img) && img.id === coverId,
            is_pro_majazi: Boolean(img) && img.id === proId,
          });
        }

        // ویژگی‌های تازه‌اضافه‌شده
        for (const a of attributes.filter((a) => !a.existingId)) {
          await addAttribute({
            product: product.id,
            title: a.name,
            value: a.value,
          });
        }
        // ویژگی‌های حذف‌شده
        for (const attrId of removedAttributeIds) {
          await deleteAttribute(attrId);
        }

        // رنگ‌های تازه‌اضافه‌شده
        for (const c of colors.filter((c) => !c.existingId)) {
          await addColor({
            product: product.id,
            name: c.name,
            hex_code: c.hex,
          });
        }
        // رنگ‌های حذف‌شده
        for (const colorId of removedColorIds) {
          await deleteColor(colorId);
        }

        await swalSuccess({
          title: "success",
          text: "محصول با موفقیت ویرایش شد",
        });

        await Promise.resolve(onSubmit?.({ id: product.id, ...payload }));
        // onBack?.();
        return;
      }

      // --- حالت افزودن محصول جدید ---
      const res = await createProduct(payload);
      const productId = res.data.id;

      // آپلود تصاویر - هر عکس با پرچم کاور بودن، دقیقا مثل ProductCreate.jsx
      for (const [idx, img] of images.entries()) {
        setUploadState({ done: idx, total: images.length });
        await uploadProductImages(productId, [
          {
            file: img.file,
            is_cover: img.id === coverId,
            is_pro_majazi: img.id === proId,
          },
        ]);
      }
      setUploadState(null);

      // ثبت ویژگی‌ها
      for (const a of attributes) {
        await addAttribute({
          product: productId,
          title: a.name,
          value: a.value,
        });
      }

      // ثبت رنگ‌ها
      for (const c of colors) {
        await addColor({
          product: productId,
          name: c.name,
          hex_code: c.hex,
        });
      }

      await swalSuccess({
        title: "success",
        text: "محصول با موفقیت ثبت شد",
      });

      await Promise.resolve(onSubmit?.(res.data));
      // onBack?.();
    } catch (err) {
      console.log("PRODUCT SUBMIT ERROR:", err.response?.data || err.message);
      swalError({
        text: err?.response?.data?.detail || "خطایی در انجام عملیات رخ داد.",
      });
    } finally {
      setSubmittingState(false);
      setUploadState(null);
    }
  };

  return (
    <div className="apf">
      <div className="apf-head">
        <button type="button" className="apf-back-btn" onClick={onBack}>
          <Icon.Back />
        </button>
        <div className="apf-head-title">
          <h1>{isEdit ? "ویرایش محصول" : "افزودن محصول جدید"}</h1>
          <p>
            {isEdit
              ? "اطلاعات محصول را ویرایش کنید و تغییرات را ذخیره کنید."
              : "اطلاعات محصول را کامل کنید تا در فروشگاه شما نمایش داده شود."}
          </p>
        </div>
      </div>

      <form className="apf-form" onSubmit={handleSubmit}>
        {/* اطلاعات محصول */}
        <section className="apf-card">
          <div className="apf-card-head">
            <div className="apf-card-ic">
              <Icon.Info />
            </div>
            <div>
              <h2>اطلاعات محصول</h2>
              <p>نام، واحد فروش و توضیحات محصول</p>
            </div>
          </div>
          <div className="apf-grid">
            <label className="apf-field">
              <span className="apf-label">نام محصول</span>
              <input
                className="apf-input"
                type="text"
                placeholder="مثلاً پیراهن مردانه کتان"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </label>
            <label className="apf-field">
              <span className="apf-label">واحد محصول</span>
              <select
                className="apf-select"
                value={unit}
                onChange={(e) => setUnit(e.target.value)}
              >
                {UNIT_OPTIONS.map((u) => (
                  <option key={u} value={u}>
                    {u}
                  </option>
                ))}
              </select>
            </label>
            <label className="apf-field apf-field--full">
              <span className="apf-label">
                توضیحات <span className="apf-label-hint">(اختیاری)</span>
              </span>
              <ApfDescriptionEditor
                value={description}
                onChange={setDescription}
              />
            </label>
          </div>
        </section>

        {/* قیمت و موجودی */}
        <section className="apf-card">
          <div className="apf-card-head">
            <div className="apf-card-ic">
              <Icon.Tag />
            </div>
            <div>
              <h2>قیمت و موجودی</h2>
              <p>قیمت فروش، قیمت بعد از تخفیف و تعداد موجودی</p>
            </div>
          </div>
          <div className="apf-grid apf-grid--3">
            <label className="apf-field">
              <span className="apf-label">قیمت</span>
              <div className="apf-input-unit">
                <input
                  className="apf-input"
                  type="text"
                  inputMode="numeric"
                  dir="ltr"
                  placeholder="0"
                  value={formatThousands(price)}
                  onChange={(e) => setPrice(onlyDigits(e.target.value))}
                  required
                />
                <span>تومان</span>
              </div>
            </label>
            <label className="apf-field">
              <span className="apf-label">
                قیمت بعد از تخفیف{" "}
                <span className="apf-label-hint">(اختیاری)</span>
              </span>
              <div className="apf-input-unit">
                <input
                  className="apf-input"
                  type="text"
                  inputMode="numeric"
                  dir="ltr"
                  placeholder="0"
                  value={formatThousands(discountPrice)}
                  onChange={(e) => setDiscountPrice(onlyDigits(e.target.value))}
                />
                <span>تومان</span>
              </div>
            </label>
            <label className="apf-field">
              <span className="apf-label">موجودی</span>
              <input
                className="apf-input"
                type="text"
                inputMode="numeric"
                dir="ltr"
                placeholder="0"
                value={formatThousands(stock)}
                onChange={(e) => setStock(onlyDigits(e.target.value))}
                required
              />
            </label>
          </div>
        </section>

        {/* دسته‌بندی */}
        <section className="apf-card">
          <div className="apf-card-head">
            <div className="apf-card-ic">
              <Icon.Grid />
            </div>
            <div className="apf-card-head-title">
              <h2>دسته‌بندی</h2>
              <p>محصول در کدام دسته و زیردسته نمایش داده شود</p>
            </div>
            <button
              type="button"
              className="apf-card-action-btn"
              onClick={() => setShowAddCategory(true)}
            >
              <Icon.Plus />
              افزودن دسته‌بندی جدید
            </button>
          </div>
          <div className="apf-grid">
            <label className="apf-field">
              <span className="apf-label">دسته‌بندی اصلی</span>
              <select
                className="apf-select"
                value={category}
                onChange={(e) => {
                  setCategory(e.target.value);
                  setSubCategory(""); // با تغییر دسته‌ی اصلی، زیردسته ریست می‌شه
                }}
                required
              >
                <option value="">انتخاب دسته‌بندی اصلی</option>
                {mainCategories.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.name}
                  </option>
                ))}
              </select>
            </label>
            <label className="apf-field">
              <span className="apf-label">
                زیردسته‌بندی <span className="apf-label-hint">(اختیاری)</span>
              </span>
              <select
                className="apf-select"
                value={subCategory}
                onChange={(e) => setSubCategory(e.target.value)}
                disabled={!category || !subCategories.length}
              >
                <option value="">
                  {!category
                    ? "ابتدا دسته‌بندی اصلی را انتخاب کنید"
                    : subCategories.length
                      ? "انتخاب زیردسته"
                      : "زیردسته‌ای برای این دسته وجود ندارد"}
                </option>
                {subCategories.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.name}
                  </option>
                ))}
              </select>
            </label>
          </div>
        </section>

        {/* ویترین‌ها */}
        <section className="apf-card">
          <div className="apf-card-head">
            <div className="apf-card-ic">
              <Icon.Storefront />
            </div>
            <div>
              <h2>ویترین‌ها</h2>
              <p>محصول در کدام ویترین‌های فروشگاه نمایش داده شود</p>
            </div>
          </div>
          <div className="apf-chip-group">
            {collections.map((item) => (
              <button
                key={item.id}
                type="button"
                className={`apf-chip ${showcases.includes(item.id) ? "apf-chip--active" : ""}`}
                onClick={() => toggleShowcase(item.id)}
              >
                {item.name}
              </button>
            ))}
          </div>
        </section>

        {/* تصاویر */}
        <section className="apf-card">
          <div className="apf-card-head">
            <div className="apf-card-ic">
              <Icon.Image />
            </div>
            <div>
              <h2>تصاویر محصول</h2>
              <p>چند تصویر آپلود کنید و یکی را به عنوان کاور انتخاب کنید</p>
            </div>
          </div>
          {(proEnabled || proId) && (
            <details className="apf-pro-guide">
              <summary>
                <Icon.Sparkle />
                راهنمای انتخاب عکس برای پرومجازی
              </summary>
              <div className="apf-pro-guide-body">
                <p className="apf-pro-guide-lead">
                  عکسی را به‌عنوان «تصویر پرومجازی» انتخاب کنید که خودِ محصول در
                  آن واضح و کامل دیده شود. روی عکس‌ها دکمه‌ی «تصویر پرومجازی» را
                  بزنید (فقط یک عکس).
                </p>
                <div className="apf-pro-guide-cols">
                  <div className="apf-pro-guide-col apf-pro-guide-col--do">
                    <h4>
                      <Icon.Check />
                      عکس مناسب
                    </h4>
                    <ul>
                      <li>محصول از روبه‌رو و کامل، بدون بریدگی از هیچ طرف</li>
                      <li>پس‌زمینه ساده و یک‌رنگ (سفید یا خاکستری روشن)</li>
                      <li>
                        محصول سالم و مرتب (بدون چروک، گرد و غبار یا لک)؛ در حالت
                        عادی و بدون پوشش یا بسته‌بندی
                      </li>
                      <li>نور یکنواخت، بدون سایه شدید یا فلاش مستقیم</li>
                      <li>کیفیت بالا و واضح (ترجیحاً حداقل ۱۰۰۰×۱۰۰۰ پیکسل)</li>
                      <li>فقط یک محصول در هر عکس</li>
                    </ul>
                  </div>
                  <div className="apf-pro-guide-col apf-pro-guide-col--dont">
                    <h4>
                      <Icon.X />
                      عکس نامناسب
                    </h4>
                    <ul>
                      <li>لوگو، واترمارک، متن یا قاب روی عکس</li>
                      <li>کولاژ یا چند محصول در یک تصویر</li>
                      <li>عکس تار، تاریک یا با زاویه کج</li>
                      <li>فرد یا مدل در عکس، یا دست و وسایل دیگر روی محصول</li>
                      <li>
                        ادیت یا فیلتر سنگین که رنگ واقعی محصول را تغییر دهد
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="apf-pro-prompt">
                  <h4>
                    <Icon.Sparkle />
                    پرامپت آماده برای هوش مصنوعی
                  </h4>
                  <p>
                    عکس محصولتان را در یک ابزار هوش مصنوعی تصویر‌ساز (مثل
                    ChatGPT یا Gemini) آپلود کنید، این متن را کپی و همراه عکس
                    ارسال کنید، سپس عکس خروجی را اینجا آپلود کنید.
                  </p>
                  <pre className="apf-pro-prompt-text">{PRO_PROMPT_FA}</pre>
                  <div className="apf-pro-prompt-actions">
                    <button
                      type="button"
                      className="apf-image-mini-btn"
                      onClick={() => copyProPrompt("fa")}
                    >
                      {copiedPrompt === "fa" ? "کپی شد ✓" : "کپی پرامپت فارسی"}
                    </button>
                    <button
                      type="button"
                      className="apf-image-mini-btn"
                      onClick={() => copyProPrompt("en")}
                    >
                      {copiedPrompt === "en"
                        ? "Copied ✓"
                        : "Copy English prompt"}
                    </button>
                  </div>
                  <p className="apf-pro-prompt-warn">
                    حتماً خروجی را بررسی کنید: رنگ و جزئیات باید دقیقاً مثل
                    محصول واقعی باشد. اگر تغییر کرده بود، دوباره تولید کنید.
                  </p>
                </div>
              </div>
            </details>
          )}
          <div className="apf-image-grid">
            {images.map((img) => (
              <div className="apf-image-slot" key={img.id}>
                <img src={img.url} alt={name || "تصویر محصول"} />
                {coverId === img.id && (
                  <span className="apf-image-cover-badge">کاور</span>
                )}
                {proId === img.id && (
                  <span className="apf-image-pro-badge">
                    <Icon.Sparkle />
                    پرومجازی
                  </span>
                )}
                <div className="apf-image-actions">
                  {coverId !== img.id && (
                    <button
                      type="button"
                      className="apf-image-mini-btn"
                      onClick={() => setCoverId(img.id)}
                    >
                      انتخاب کاور
                    </button>
                  )}
                  {(proEnabled || proId === img.id) && (
                    <button
                      type="button"
                      className={`apf-image-mini-btn ${proId === img.id ? "apf-image-mini-btn--active" : ""}`}
                      onClick={() => toggleProImage(img.id)}
                    >
                      {proId === img.id ? "لغو پرومجازی" : "تصویر پرومجازی"}
                    </button>
                  )}
                  <button
                    type="button"
                    className="apf-image-mini-btn apf-image-mini-btn--danger"
                    onClick={() => removeImage(img.id)}
                  >
                    حذف
                  </button>
                </div>
              </div>
            ))}
            <button
              type="button"
              className="apf-image-add"
              onClick={() => fileInputRef.current?.click()}
            >
              <Icon.Plus />
              <span>افزودن عکس</span>
            </button>
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              multiple
              hidden
              onChange={(e) => handleFiles(e.target.files)}
            />
          </div>
          <p className="apf-hint">
            <span className="apf-hint-desktop">
              برای انتخاب کاور، نشانگر ماوس را روی تصویر مورد نظر ببرید و
              «انتخاب کاور» را بزنید.{" "}
            </span>
            <span className="apf-hint-mobile">
              برای انتخاب کاور، روی دکمه‌ی «انتخاب کاور» در پایین هر تصویر
              بزنید.{" "}
            </span>
            تصاویر به صورت خودکار بهینه‌سازی و فشرده می‌شوند. همچنین می‌توانید
            با «تصویر پرومجازی» مشخص کنید کدام عکس برای پرو آنلاین (پرومجازی)
            استفاده شود (اختیاری، حداکثر یک تصویر).
          </p>
        </section>

        {/* افزودن ویژگی */}
        <section className="apf-card">
          <div className="apf-card-head">
            <div className="apf-card-ic">
              <Icon.Sparkle />
            </div>
            <div>
              <h2>ویژگی‌های محصول</h2>
              <p>مثل: جنس، سایز، وزن و سایر مشخصات فنی</p>
            </div>
          </div>
          <div className="apf-add-row">
            <label className="apf-field">
              <span className="apf-label">نام ویژگی</span>
              <input
                className="apf-input"
                type="text"
                placeholder="مثلاً جنس"
                value={attrName}
                onChange={(e) => setAttrName(e.target.value)}
              />
            </label>
            <label className="apf-field">
              <span className="apf-label">مقدار ویژگی</span>
              <input
                className="apf-input"
                type="text"
                placeholder="مثلاً کتان ۱۰۰٪"
                value={attrValue}
                onChange={(e) => setAttrValue(e.target.value)}
              />
            </label>
            <button
              type="button"
              className="apf-mini-add-btn"
              onClick={addAttr}
              disabled={!attrName.trim() || !attrValue.trim()}
            >
              <Icon.Plus />
              افزودن ویژگی
            </button>
          </div>
          {attributes.length ? (
            <div className="apf-tag-list">
              {attributes.map((a) => (
                <span className="apf-tag" key={a.id}>
                  <b>{a.name}:</b> {a.value}
                  <button
                    type="button"
                    className="apf-tag-remove"
                    onClick={() => removeAttribute(a.id)}
                  >
                    <Icon.X />
                  </button>
                </span>
              ))}
            </div>
          ) : (
            <p className="apf-empty-note">هنوز ویژگی‌ای اضافه نشده است.</p>
          )}
        </section>

        {/* رنگ‌ها */}
        <section className="apf-card">
          <div className="apf-card-head">
            <div className="apf-card-ic">
              <Icon.Palette />
            </div>
            <div>
              <h2>رنگ‌های محصول</h2>
              <p>رنگ‌های موجود برای این محصول را اضافه کنید</p>
            </div>
          </div>
          <div className="apf-add-row">
            <label className="apf-field">
              <span className="apf-label">نام رنگ</span>
              <input
                className="apf-input"
                type="text"
                placeholder="مثلاً سرمه‌ای"
                value={colorName}
                onChange={(e) => setColorName(e.target.value)}
              />
            </label>
            <label className="apf-field">
              <span className="apf-label">کد رنگ (Hex)</span>
              <div className="apf-color-swatch-input">
                <input
                  type="color"
                  value={colorHex}
                  onChange={(e) => setColorHex(e.target.value)}
                />
                <input
                  type="text"
                  value={colorHex}
                  onChange={(e) => setColorHex(e.target.value)}
                  spellCheck={false}
                />
              </div>
            </label>
            <button
              type="button"
              className="apf-mini-add-btn"
              onClick={addCol}
              disabled={!colorName.trim()}
            >
              <Icon.Plus />
              افزودن رنگ
            </button>
          </div>
          {colors.length ? (
            <div className="apf-tag-list">
              {colors.map((c) => (
                <span className="apf-tag" key={c.id}>
                  <span
                    className="apf-tag-swatch"
                    style={{ background: c.hex }}
                  />
                  <b>{c.name}</b>
                  <span
                    className="apf-mono"
                    style={{ color: "rgba(43,18,76,0.5)" }}
                  >
                    {c.hex}
                  </span>
                  <button
                    type="button"
                    className="apf-tag-remove"
                    onClick={() => removeColor(c.id)}
                  >
                    <Icon.X />
                  </button>
                </span>
              ))}
            </div>
          ) : (
            <p className="apf-empty-note">هنوز رنگی اضافه نشده است.</p>
          )}
        </section>

        {/* ثبت محصول */}
        <div className="apf-submit-bar">
          <span className="apf-submit-note">
            {isEdit
              ? "پیش از ذخیره، اطلاعات ویرایش‌شده را بازبینی کنید."
              : "پیش از ثبت، اطلاعات وارد‌شده را بازبینی کنید."}
          </span>
          <button
            className="apf-submit-btn"
            type="submit"
            disabled={submitting}
          >
            <Icon.Check />
            {isEdit
              ? submitting
                ? "در حال ذخیره..."
                : "ذخیره تغییرات"
              : submitting
                ? "در حال ثبت..."
                : "ثبت محصول"}
          </button>
        </div>
      </form>

      {showAddCategory && (
        <div className="apf-modal-overlay" onClick={closeAddCategoryModal}>
          <div className="apf-modal" onClick={(e) => e.stopPropagation()}>
            <div className="apf-modal-head">
              <h3>افزودن دسته‌بندی جدید</h3>
              <button
                type="button"
                className="apf-modal-close"
                onClick={closeAddCategoryModal}
              >
                <Icon.X />
              </button>
            </div>
            <div className="apf-modal-body">
              <label className="apf-field">
                <span className="apf-label">نام دسته‌بندی جدید</span>
                <input
                  className="apf-input"
                  type="text"
                  placeholder="مثلاً پوشاک زنانه"
                  value={newCategoryName}
                  onChange={(e) => setNewCategoryName(e.target.value)}
                  autoFocus
                />
              </label>
              <label className="apf-field">
                <span className="apf-label">
                  زیرمجموعه‌ی <span className="apf-label-hint">(اختیاری)</span>
                </span>
                <select
                  className="apf-select"
                  value={newCategoryParent}
                  onChange={(e) => setNewCategoryParent(e.target.value)}
                >
                  <option value="">دسته‌بندی اصلی مستقل</option>
                  {mainCategories.map((c) => (
                    <option key={c.id} value={c.id}>
                      زیردسته‌ی «{c.name}»
                    </option>
                  ))}
                </select>
              </label>
            </div>
            <div className="apf-modal-actions">
              <button
                type="button"
                className="apf-modal-cancel-btn"
                onClick={closeAddCategoryModal}
              >
                انصراف
              </button>
              <button
                type="button"
                className="apf-submit-btn"
                onClick={handleAddCategory}
                disabled={!newCategoryName.trim() || addingCategory}
              >
                <Icon.Check />
                {addingCategory ? "در حال افزودن..." : "ثبت دسته‌بندی"}
              </button>
            </div>
          </div>
        </div>
      )}
      {submitting && uploadState && (
        <div className="apf-upload-overlay" role="status" aria-live="polite">
          <div className="apf-upload-box">
            <div className="apf-upload-spinner" />
            <p className="apf-upload-title">
              در حال آپلود تصویر{" "}
              {(uploadState.done + 1).toLocaleString("fa-IR")} از{" "}
              {uploadState.total.toLocaleString("fa-IR")}
            </p>
            <div className="apf-upload-bar">
              <div
                className="apf-upload-bar-fill"
                style={{
                  width: `${Math.max(
                    8,
                    (uploadState.done / uploadState.total) * 100,
                  )}%`,
                }}
              />
            </div>
            <p className="apf-upload-hint">
              لطفاً تا پایان آپلود صفحه را نبندید.
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
